<icms-outlet-block [name]="'500page'"
                   [variant]="'500-page'"></icms-outlet-block>
